export const debounce = (func, time) => {
  let timeoutId;
  return function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, arguments), time);
  };
};

export const chainAsyncCalls = func => {
  const previousPromises = [];
  return async function() {
    for (const promise of previousPromises) {
      await promise;
      previousPromises.splice(0, 1);
    }
    const promise = func.apply(this, arguments);
    previousPromises.push(promise);
    return await promise;
  }
};